"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findElementByAttr = exports.findClosetFiber = exports.findElementBy = exports.findElement = exports.findFiberInstance = exports.getFiberKey = exports.SYMBOL_LC_NAME = exports.SYMBOL_LC = void 0;
var react_dom_1 = __importDefault(require("react-dom"));
exports.SYMBOL_LC = '_LC_ID';
exports.SYMBOL_LC_NAME = '_LC_NAME';
var REACT_KEY = '';
var FIBER_KEY;
var getFiberKey = function (dom) {
    if (REACT_KEY)
        return true;
    if (isHTMLElement(dom)) {
        REACT_KEY = Object.keys(dom).find(function (key) {
            if (key.startsWith('__reactFiber$')) { // react 17+
                FIBER_KEY = '_reactInternals';
                return true;
            }
            if (key.startsWith('__reactInternalInstance$')) { // react <17
                FIBER_KEY = '_reactInternalFiber';
                return true;
            }
            return false;
        });
        return false;
    }
    if (dom._reactInternals) {
        REACT_KEY = '_reactInternals';
        return true;
    }
    if (dom._reactInternalFiber) {
        REACT_KEY = '_reactInternalFiber';
        return true;
    }
    return false;
};
exports.getFiberKey = getFiberKey;
var findFiberInstance = function (_dom, isFindLcInstance) {
    var _a, _b, _c;
    if (isFindLcInstance === void 0) { isFindLcInstance = true; }
    var dom = _dom;
    (0, exports.getFiberKey)(dom);
    var domFiber = (_a = (0, exports.findClosetFiber)(dom, 15)) === null || _a === void 0 ? void 0 : _a[1];
    if (domFiber === null)
        return null;
    var detectTarget = typeof isFindLcInstance === 'function' ? isFindLcInstance : function (inst) {
        var _a;
        if (isFindLcInstance === true)
            return !!((_a = inst.stateNode) === null || _a === void 0 ? void 0 : _a[exports.SYMBOL_LC]);
        return !!inst.stateNode[FIBER_KEY];
    };
    /** 查找 fiber 节点 */
    var getCompFiber = function (fiber) {
        var parentFiber = fiber;
        if (!parentFiber)
            return;
        // eslint-disable-next-line
        while (true) {
            if (detectTarget(parentFiber)) {
                return parentFiber;
            }
            parentFiber = parentFiber.return;
            if (!parentFiber)
                return null;
        }
    };
    var instance = (_b = getCompFiber(domFiber)) === null || _b === void 0 ? void 0 : _b.stateNode;
    if (!instance) {
        return null;
    }
    return {
        nodeId: instance[exports.SYMBOL_LC],
        componentName: instance[exports.SYMBOL_LC_NAME],
        realInstance: (_c = instance[FIBER_KEY]) === null || _c === void 0 ? void 0 : _c.stateNode,
        instance: instance,
        // @todo replacement for findNode
        // eslint-disable-next-line
        dom: (0, exports.findElement)(instance),
    };
};
exports.findFiberInstance = findFiberInstance;
// eslint-disable-next-line
var findElement = function (/** ReactInstance */ instance) { return react_dom_1.default.findDOMNode(instance); };
exports.findElement = findElement;
var isHTMLElement = function (obj) { return obj instanceof HTMLElement; };
var findElementBy = function (predict, node, traverse) {
    if (traverse === void 0) { traverse = 5; }
    var el = node;
    var i = traverse;
    var propVal = '';
    while (el && i > 0) {
        propVal = predict(el);
        if (propVal)
            break;
        i -= 1;
        el = el.parentElement;
    }
    return propVal ? [el, propVal] : [null, undefined];
};
exports.findElementBy = findElementBy;
/** 查找最近的Fiber节点.由于 dangerouslyHTML 的 element 不属于 fiber 管理范畴, 所以要向上查询*/
exports.findClosetFiber = exports.findElementBy.bind(null, function (el) { return el[REACT_KEY]; });
var findElementByAttr = function (event, attr, traverse) {
    if (traverse === void 0) { traverse = 15; }
    var el = event.target;
    return (0, exports.findElementBy)(function (el) { return el.dataset[attr]; }, el, traverse);
};
exports.findElementByAttr = findElementByAttr;
